export const formatCurrency = (value: string) => {
  if (!value) {
    return "0";
  }
  if (value.slice(-3) === ".00") {
    return value.slice(0, -3);
  }
  return value;
};

export const currency = (money: number) => {
  return new Intl.NumberFormat().format(money);
};
